<template>
  <div class="duplicate-bpmn-schema">
    <q-form class="duplicate-bpmn-schema__form" @submit.prevent="onSubmit">
      <div class="duplicate-bpmn-schema__field">
        <CustomInput
          :value="newSchemaName"
          type="number"
          :integer="true"
          :controls="true"
          label="Номер новой схемы"
          placeholder="Например, 12"
          :required="true"
          @change_input="onNameChange"
        />
      </div>
      <div class="duplicate-bpmn-schema__field">
        <CustomInput
          :value="newSchemaDesc"
          type="textarea"
          :rows="4"
          label="Описание схемы"
          placeholder="Введите описание новой схемы"
          @change_input="onDescChange"
        />
      </div>
      <div class="duplicate-bpmn-schema__field">
        <CustomSelect
          label="Дублировать из схемы"
          :required="true"
          placeholder="Выберите схему"
          :options="schemaOptions"
          option-value-key="schema_id"
          option-label-key="label"
          :value="sourceSchemaId"
          @change="(val) => (sourceSchemaId = val)"
        />
      </div>
      <CustomModalFooter
        :btn-loading="loading"
        submit-btn-text="Создать"
        :disable-submit="!canSubmit"
      />
    </q-form>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import CustomInput from '@/components/form/CustomInput'
import CustomSelect from '@/components/form/CustomSelect'
import CustomModalFooter from '@/components/modal/modals/modal-footer'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  closeModal: {
    type: Function,
    default: () => {},
  },
})

const loading = ref(false)
const newSchemaName = ref('')
const newSchemaDesc = ref('')
const sourceSchemaId = ref(null)

const schemaOptions = computed(() => props.data?.schemaOptions ?? [])

function onNameChange(val) {
  newSchemaName.value = val === '' || val === null || val === undefined ? '' : String(val)
}

function onDescChange(val) {
  newSchemaDesc.value = val === '' || val === null || val === undefined ? '' : String(val)
}

const canSubmit = computed(() => {
  const name = String(newSchemaName.value ?? '').trim()
  const n = parseInt(name, 10)
  if (!name || Number.isNaN(n) || n < 0 || String(n) !== name) return false
  return sourceSchemaId.value != null
})

async function onSubmit() {
  if (!canSubmit.value) return
  loading.value = true
  const body = {
    new_schema_name: Number(String(newSchemaName.value).trim()),
    source_schema_id: sourceSchemaId.value,
  }
  const descTrimmed = String(newSchemaDesc.value ?? '').trim()
  if (descTrimmed) {
    body.new_schema_desc = descTrimmed
  }
  await props.data?.onSubmit?.(body)
  loading.value = false
}
</script>

<style scoped lang="scss">
.duplicate-bpmn-schema {
  max-width: 440px;
  width: 100%;
}

.duplicate-bpmn-schema__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
}

.duplicate-bpmn-schema__field {
  width: 100%;
}
</style>
